import { p as proxyCustomElement, H, c as createEvent, h, a as Host } from './index.js';
import { d as defineCustomElement$4 } from './p-aAvJ0uEW.js';
import { d as defineCustomElement$3 } from './p-CPK1giqP.js';
import { d as defineCustomElement$2 } from './p-Bjt5CD4D.js';
import { d as defineCustomElement$1 } from './p-QtR5VUMp.js';

const tabsCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:baseline;box-sizing:border-box;display:flex;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;overflow-x:auto;width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host([type=tab]){box-shadow:inset 0 -1px 0 0 var(--jw-theme-surface-border-border-color);gap:1.5rem}:host([type=tab-button]){width:-webkit-fit-content;width:fit-content}:host([type=tab-button]) wui-tab{border-bottom:1px solid var(--jw-theme-form-border-regular-default-border-color);border-right:1px solid var(--jw-theme-form-border-regular-default-border-color);border-top:1px solid var(--jw-theme-form-border-regular-default-border-color);overflow:hidden}:host([type=tab-button]) wui-tab:first-of-type{border-bottom-left-radius:.25rem;border-left:1px solid var(--jw-theme-form-border-regular-default-border-color);border-top-left-radius:.25rem}:host([type=tab-button]) wui-tab:last-of-type{border-bottom-right-radius:.25rem;border-top-right-radius:.25rem}";

const WuiTabs = /*@__PURE__*/ proxyCustomElement(class WuiTabs extends H {
    constructor(registerHost) {
        super();
        if (registerHost !== false) {
            this.__registerHost();
        }
        this.__attachShadow();
        this.selectTab = createEvent(this, "selectTab", 3);
        /**
         * Display type for all tabs
         */
        this.type = 'tab';
    }
    handleSelectTab(id) {
        this.activeTabId = id;
        this.selectTab?.emit(id);
    }
    render() {
        return (h(Host, { key: 'd75a607da0e759949df435dc998334c3719a3856' }, this.tabs?.map((tab) => {
            const { id, hidden, ...tabProps } = tab;
            if (hidden) {
                return null;
            }
            return (h("wui-tab", { tabIndex: 0, key: id, ...tabProps, active: this.activeTabId === id, type: this.type, onActivate: () => {
                    this.handleSelectTab(id);
                } }));
        })));
    }
    static get style() { return tabsCss; }
}, [257, "wui-tabs", {
        "tabs": [16],
        "type": [513],
        "activeTabId": [1025, "active-tab-id"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-tabs", "wui-icon", "wui-tab", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-tabs":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiTabs);
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tab":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiTabs as W, defineCustomElement as d };
